import UnitInputPage from "@components/UnitInputPage"

export default function GoalWeight() {
  return (
    <UnitInputPage
      translationKey="goalWeight"
      metricUnit={{
        value: "kg",
        label: "kg",
        placeholder: "65",
        conversionFactor: 1,
      }}
      imperialUnit={{
        value: "lb",
        label: "lb",
        placeholder: "143",
        conversionFactor: 0.453592,
      }}
    />
  )
}
